import React from "react";
import { useNavigate } from "react-router-dom"; 
import "./LandingPage2.css"; 
import logo from "../../img/Wa.I.San Jpeg final.jpg"; 

const LandingPage = () => {
  const navigate = useNavigate(); // Initialize useNavigate hook

  // Function to handle navigation
  const navigateHome = () => {
    navigate("/home"); 
  };

  return (
    <div className="landing-container">
      <div className="overlay">
        {/* Logo Section */}
        <div className="landing-logo">
          <img src={logo} alt="Wā.I.Saṅ Logo" className="logo" />
        </div>

        {/* Button Section */}
       

        {/* New Text Section */}
        <div className="new-text-container">
          <div className="new-text-title">Wā.I.Saṅ</div>
          <div className="new-text-subtitle">Wārsā Itihās and Saṅskritī!</div>
          <div className="new-text-description">Celebrating heritage</div>
        </div>

        <button className="explore-button" onClick={navigateHome}>
          Explore
        </button>
      </div>
    </div>
  );
};

export default LandingPage;
